import React from 'react';
import HotelContactStyle1 from './HotelContactStyle1';

const blogOpen:boolean = true;

const HotelContact = () => {

  if(!blogOpen) return 

  return (
    <div style={{display:blogOpen ? "block" : "none"}}>
      <HotelContactStyle1 />
    </div>
  );
};

export default HotelContact;